import { Flex, FlexProps } from "@chakra-ui/react";
import { FC, PropsWithChildren } from "react";

const ActionBar: FC<PropsWithChildren<FlexProps>> = ({
  children,
  ...props
}) => (
  <Flex
    maxWidth={[null, null, "100%"]}
    w={["100vw", null, "100%"]}
    borderRadius={[null, null, 10]}
    mx="auto"
    px={5}
    position={["relative", null, "static"]}
    bottom={[-6, null, 0]}
    backgroundColor="#cbd5e0"
    py={6}
    mt={["auto", null, 10]}
    left={["50%", null, "auto"]}
    right={["50%", null, "auto"]}
    ml={["-50vw", null, "auto"]}
    mr={["-50vw", null, "auto"]}
    {...props}
  >
    <Flex
      w="100%"
      direction={["column", "row"]}
      mx="auto"
      gap={[4, 2, 4]}
      flexWrap="wrap"
      justifyContent={["center", null, "flex-start"]}
    >
      {children}
    </Flex>
  </Flex>
);

export default ActionBar;
